import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ id, children, className = '' }) => {
    return (
        <section id={id} className={`py-20 md:py-32 ${className}`}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.6 }}
                className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
            >
                {children}
            </motion.div>
        </section>
    );
};

export default Section;
